import { InjectionToken } from '@angular/core';
import { PwaConfig } from '../model/pwa-config';

/**
 * Provides a token to override default settings. You can use this token to enhance our library
 * and configure multiple sites/app on the same environment.
 */
export const PWA_CONFIG = new InjectionToken<PwaConfig>('pwa-config');
